export const FETCH_DOCUMENTS_REQUEST = "OPERATOR_FILE_UPLOAD_REQUEST";
export const FETCH_DOCUMENTS_SUCCESS = "OPERATOR_FILE_UPLOAD_SUCCESS";
export const FETCH_DOCUMENTS_FAILURE = "OPERATOR_FILE_UPLOAD_FAILURE";
